import { COLLECTIONS, STATUSES } from '__constants__'
import { deleteDocument, updateDocument } from 'services/api/firebase'
import { generatePath, useHistory } from 'react-router-dom'

import PATHS from 'pages/paths'
import { deleteStorageFile } from 'helpers'
import { message } from 'antd'
import { useEvent } from 'hooks'
import { useMemo } from 'react'
import { useTranslations } from 'contexts/Translation'

/* Path's */
const createPath =
  PATHS.AUTHENTICATED.NEWSPAPER_CREATE || PATHS.AUTHENTICATED.NEWSPAPER_WIZARD
const editPath = PATHS.AUTHENTICATED.NEWSPAPER_EDIT
const showPath = PATHS.AUTHENTICATED.NEWSPAPER_SHOW

const useNewspaperBaseActions = ({
  newspaperId,
  actions,
  logoUrl,
  isBlocked
} = {}) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance */
  const history = useHistory()

  /* Function to handle back click */
  const handleBack = useEvent(() => history.goBack())

  /* Handling opening of the create page */
  const handleCreate = useEvent(() => {
    history.push(createPath)
  })

  /* Handling opening of the edit page or change view to edit mode */
  const handleEdit = useEvent(() => {
    const pathParams = { newspaperId }
    const path = generatePath(editPath, pathParams)
    history.push(path)
  })

  const handleDelete = useEvent(async () => {
    try {
      await deleteDocument(COLLECTIONS.NEWSPAPERS, newspaperId)
      logoUrl && (await deleteStorageFile(logoUrl))
      message.success(t('Newspaper successfully deleted'))
    } catch (error) {
      message.error(error.message)
    }
  })

  const handleBlock = useEvent(async () => {
    const statusActive = t(STATUSES.NEWSPAPER_STATUSES.ACTIVE)
    const statusBlocked = t(STATUSES.NEWSPAPER_STATUSES.BLOCKED)

    const computedStatus = isBlocked ? statusActive : statusBlocked

    try {
      await updateDocument(COLLECTIONS.NEWSPAPERS, newspaperId, {
        status: computedStatus,
        isBlocked: isBlocked ? false : true
      })

      message.success(t(`Newspaper successfully ${computedStatus}`))
    } catch (error) {
      console.error(t(`Error ${computedStatus} newspaper`, error))

      message.error(t(`Error ${computedStatus} newspaper`))
    }
  })

  return useMemo(
    () => ({
      onBack: handleBack,
      onCreate: handleCreate,
      onEdit: handleEdit,
      onDelete: handleDelete,
      onBlock: handleBlock,
      ...(actions || {}),
      createPath,
      editPath,
      showPath
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      actions?.onBack,
      actions?.onCreate,
      actions?.onDelete,
      actions?.onEdit,
      actions?.onOpen,
      actions?.onBlock,
      handleBack,
      handleCreate,
      handleDelete,
      handleEdit,
      handleBlock
    ]
  )
}

export default useNewspaperBaseActions
